<template>
	<AppLayout>

		<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing pt-2">
			<div class="widget widget-six">
				<div class="widget-heading d-block">
					<div class="row">
						<div class="col-12 d-inline-flex align-items-center">
							<h4 class="me-3 my-0">Delegacje za okres: {{ formattedMonth }}</h4>
						</div>
					</div>
				</div>

				<div class="widget-content">
					<div class="row col-12 mb-3">
						<div class="col-auto d-flex mb-3">
							<label for="monthSelect" class="me-2">Miesiąc:</label>
							<select id="monthSelect" v-model="selectedMonth" class="form-select form-select-sm w-100" style="min-width:150px">
								<option v-for="(month, index) in availableMonths" :key="index" :value="index">
									{{ month }}
								</option>
							</select>
						</div>
						<div class="col-auto mx-2 d-flex mb-3">
							<label for="yearSelect" class="me-2">Rok:</label>
							<select id="yearSelect" v-model="selectedYear" class="form-select form-select-sm w-100" style="min-width:150px">
								<option v-for="year in yearRange" :key="year" :value="year">
									{{ year }}
								</option>
							</select>
						</div>
						<div class="d-flex justify-content-end mb-3">
							<button type="button" class="btn btn-primary me-5" @click="addDelegacja">
								<i class="bi bi-plus-lg me-1"></i>
								Dodaj delegację
							</button>
							<button type="button" class="btn btn-success me-3" @click="exportExcel">
								<i class="bi bi-file-earmark-excel me-1"></i>
								Excel
							</button>
							<button type="button" class="btn btn-info me-3" @click="exportPdf">
								<i class="bi bi-file-earmark-pdf me-1"></i>
								PDF
							</button>
							<button type="button" class="btn btn-outline-warning me-3" @click="addZlecenia">
								Pracownicy - zlecenia
							</button>
							<button type="button" class="btn btn-outline-info me-3" @click="addKarta">
								Karty debetowe
							</button>
							<button type="button" class="btn btn-outline-info me-3" @click="addCel">
								Cele delegacji
							</button>
							<button type="button" class="btn btn-outline-info me-3" @click="addWaluta">
								Waluty
							</button>
							<button type="button" class="btn btn-outline-info" @click="addPojazd">
								Pojazdy
							</button>
						</div>
						<div class="table-toolbar mt-3 mb-3">
							<div class="search-box">
								<i class="bi bi-search"></i>
								<input v-model="searchQuery" type="text" class="form-control" placeholder="Szukaj..."/>
								<button v-if="searchQuery" type="button" class="search-clear" @click="searchQuery = ''" title="Wyczyść">
								  <i class="bi bi-x-lg"></i>
								</button>
							</div>
							<div class="table-info">
								<span>
									Wyniki:
									<strong>{{ filteredDelegacje.length }}</strong>
								</span>
								<select v-model.number="perPage" class="form-select form-select-sm">
									<option :value="25">25 / str.</option>
									<option :value="50">50 / str.</option>
									<option :value="100">100 / str.</option>
									<option :value="5000">Wszystko</option>
								</select>
							</div>
						</div>
						<div class="table-responsive delegacje-table-wrapper">
							<table class="table table-bordered delegacje-table">
								<thead>
									<tr>
										<th style="text-align:left; min-width:120px;white-space:nowrap;">Data</th>
										<th style="text-align:left; min-width:120px;white-space:nowrap;">Numer delegacji</th>
										<th style="text-align:left; min-width:120px;white-space:nowrap;">Imię i nazwisko</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Miejsce/Klient</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Projekt</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Cel</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Pojazd</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Karta debetowa</th>
										<th style="text-align:center; min-width:100px;white-space:nowrap;">Rozliczony/a</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Kwota pobrana</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Paliwo</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Jedzenie</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Hotel</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Drogi płatne</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Części i inne</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Diety</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Samochód</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Koszty delegacji</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Koszty w PLN</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Koszty Paliwo PLN</th>
										<th style="text-align:center; min-width:120px;white-space:nowrap;">Koszty Jedzenie PLN</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="delegacja in paginatedDelegacje" :key="delegacja.id" :class="{ 'delegacja-usunieta': delegacja.deleted_at }">
										<td style="text-align: left;white-space:nowrap;cursor: pointer;"
											@click="openEditDelegacja(delegacja)">
											{{ delegacja.start_date }}
											<span v-if="delegacja.end_date !== delegacja.start_date">
												- {{ delegacja.end_date }}
											</span>
										</td>

										<td style="text-align:right;white-space:nowrap;cursor:pointer;"
											:class="{ 'delegacja-nierozliczona': !delegacja.rozliczony }"
											@click="openEditDelegacja(delegacja)">
											{{ delegacja.numer }}
										</td>

										<td style="text-align:left;white-space:nowrap;cursor: pointer;"
										@click="delegacja.user?.id < 500000 && !delegacja.deleted_at && openUserColor(delegacja.user)"
										:style="delegacja.deleted_at ? {} : { 
											backgroundColor: delegacja.user?.kadry_color?.bgcolor, 
											color: delegacja.user?.kadry_color?.font_color 
										}">
											{{ delegacja.user?.first_name }} {{ delegacja.user?.last_name }}
										</td>
										<td style="text-align: center;cursor: pointer;"
											@click="openEditDelegacja(delegacja)">
											{{ delegacja.miejsce }}
										</td>
										<td style="text-align: center;white-space:nowrap;cursor: pointer;"
											@click="openEditDelegacja(delegacja)">
											{{ delegacja.project?.number }}
										</td>
										<td style="text-align: center;cursor: pointer;"
											@click="openEditDelegacja(delegacja)">
											{{ delegacja.cel }}
										</td>
										<td style="text-align: center;white-space:nowrap;cursor:pointer;"
											@click="openEditDelegacja(delegacja)">
											<span v-for="(p, index) in getPojazdy(delegacja.pojazd)"
												  :key="index">
												{{ p }}
												<br v-if="index + 1 < getPojazdy(delegacja.pojazd).length">
											</span>
										</td>
										<td style="text-align: center;white-space:nowrap;cursor: pointer;"
											@click="openEditDelegacja(delegacja)">
											{{ delegacja.card }}
										</td>
										<td style="text-align:center;cursor: pointer;"
											@click="openEditDelegacja(delegacja)">
											{{ delegacja.rozliczony ? 'TAK' : 'NIE' }}
										</td>
										<td style="text-align:right;cursor: pointer;" @click="openEditPobrane(delegacja)">
											<div v-if="delegacja.saldo">
												<div v-for="(kwota, waluta) in delegacja.saldo" :key="waluta"
													class="saldo-czerwone">
													{{ kwota.toFixed(2) }} {{ waluta }}
												</div>
											</div>
										</td>
										<td style="text-align:right;cursor: pointer;" @click="openEditKoszta(delegacja)">
											<div v-for="(kwota, waluta) in (delegacja.koszty_suma[1] || {})"
												:key="waluta">
												{{ kwota.toFixed(2) }} {{ waluta }}
											</div>
										</td>
										<td style="text-align:right;cursor: pointer;" @click="openEditKoszta(delegacja)">
											<div v-for="(kwota, waluta) in (delegacja.koszty_suma[2] || {})"
												:key="waluta">
												{{ kwota.toFixed(2) }} {{ waluta }}
											</div>
										</td>
										<td style="text-align:right;cursor: pointer;" @click="openEditKoszta(delegacja)">
											<div v-for="(kwota, waluta) in (delegacja.koszty_suma[3] || {})"
												:key="waluta">
												{{ kwota.toFixed(2) }} {{ waluta }}
											</div>
										</td>
										<td style="text-align:right;cursor: pointer;" @click="openEditKoszta(delegacja)">
											<div v-for="(kwota, waluta) in (delegacja.koszty_suma[4] || {})"
												:key="waluta">
												{{ kwota.toFixed(2) }} {{ waluta }}
											</div>
										</td>

										<td style="text-align:right;cursor: pointer;" @click="openEditKoszta(delegacja)">
											<div v-for="(kwota, waluta) in (delegacja.koszty_suma[5] || {})"
												:key="waluta">
												{{ kwota.toFixed(2) }} {{ waluta }}
											</div>
										</td>
										<td style="text-align:right;cursor: pointer;" @click="openEditKoszta(delegacja)">
											<div v-for="(kwota, waluta) in (delegacja.koszty_suma[6] || {})"
												:key="waluta">
												{{ kwota.toFixed(2) }} {{ waluta }}
											</div>
										</td>
										<td style="text-align:right;cursor: pointer;" @click="openEditKoszta(delegacja)">
											<div v-for="(kwota, waluta) in (delegacja.koszty_suma[7] || {})"
												:key="waluta">
												{{ kwota.toFixed(2) }} {{ waluta }}
											</div>
										</td>										
										<td style="text-align:right;font-weight:bold;">
											<div v-for="(kwota, waluta) in delegacja.suma_kosztow" :key="waluta">
												{{ kwota.toFixed(2) }} {{ waluta }}
											</div>
										</td>
										<td style="text-align:right;font-weight:bold;">
												{{ delegacja.suma_pln.toFixed(2) }} PLN
										</td>										
										<td style="text-align:right;font-weight:bold;">
											{{ delegacja.paliwo_pln.toFixed(2) }} PLN
										</td>

										<td style="text-align:right;font-weight:bold;">
											{{ delegacja.jedzenie_pln.toFixed(2) }} PLN
										</td>
									</tr>
								</tbody>
							</table>
							<div v-if="pageCount > 1" class="pagination-wrapper">
								<div class="pagination-info">
									{{ paginationStart }}–{{ paginationEnd }} z {{ filteredDelegacje.length }}
								</div>
								<div class="pagination-custom">
									<button class="page-btn" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
										<i class="bi bi-chevron-left"></i>
									</button>
									<template v-for="(page, index) in visiblePages" :key="index">
										<span v-if="page === '...'" class="page-dots">
											...
										</span>
										<button v-else class="page-btn" :class="{ active: page === currentPage }" @click="goToPage(page)">
											{{ page }}
										</button>
									</template>
									<button class="page-btn" :disabled="currentPage === pageCount" @click="goToPage(currentPage + 1)">
										<i class="bi bi-chevron-right"></i>
									</button>
								</div>
							</div>							
						</div>
					</div>
				</div>
			</div>
		</div>

		<AddDelegacjaModal ref="addDelegacjaModalRef" @save-delegacja="createDelegacjaFromModal"
			@added-success="successMsg" @added-error="errorMsg" :users="usersLocal" :selectedYear="selectedYear"
			:selectedMonth="selectedMonth" :currencys="currencysLocal" :karty="kartyLocal" :cele="celeLocal" :pojazdy="pojazdyLocal"
			:projects="projects" />

		<UserColorModal v-if="selectedColorUser" ref="userColorModalRef" :user="selectedColorUser"
			:userColors="userColorsLocal" @save-color="saveUserColor" />

		<EditDelegacjaModal v-if="selectedEditDelegacja" ref="editDelegacjaModalRef" :delegacja="selectedEditDelegacja"
			:users="usersLocal" :projects="projects" :karty="kartyLocal" :cele="celeLocal"
			@update-delegacja="updateDelegacja" @delete-delegacja="deleteDelegacja" :pojazdy="pojazdyLocal" :readonly="!!selectedEditDelegacja?.deleted_at"/>

		<AddKartaModal ref="addKartaModalRef" :karty="kartyLocal" @save-karta="createKartaFromModal"
			@update-karta="updateKartaFromModal" @delete-karta="deleteKartaFromModal" />

		<AddCelModal ref="addCelModalRef" :cele="celeLocal" @save-cel="createCelFromModal"
			@update-cel="updateCelFromModal" @delete-cel="deleteCelFromModal" />

		<AddPojazdModal ref="addPojazdModalRef" :pojazdy="pojazdyLocal" @save-pojazd="createPojazdFromModal"
			@update-pojazd="updatePojazdFromModal" @delete-pojazd="deletePojazdFromModal"/>

		<AddZleceniaModal ref="addZleceniaModalRef" :zlecenia="zleceniaLocal" @save-zlecenie="createZleceniaFromModal"
			@update-zlecenie="updateZleceniaFromModal" @delete-zlecenie="deleteZleceniaFromModal"/>
			
		<WalutyModal ref="addWalutaModalRef" :currencys="currencysLocal" @save-currency="storeCurrency"
			@update-currency="updateCurrency" @delete-currency="destroyCurrency" />

<EditPobraneModal 
    v-if="selectedDelegacja" 
    ref="editPobraneModalRef" 
    :delegacja="selectedDelegacja" 
    :currencys="currencysLocal"
	:readonly="!!selectedEditDelegacja?.deleted_at"
    @save-kwota="saveKwota"
    @update-kwota="updateKwota"
    @delete-kwota="deleteKwota"
/>

<EditKosztaModal 
    v-if="selectedDelegacja" 
    ref="editKosztaModalRef" 
    :delegacja="selectedDelegacja" 
    :currencys="currencysLocal"
	:readonly="!!selectedEditDelegacja?.deleted_at"
    @save-koszta="saveKoszta"
    @update-koszta="updateKoszta"
    @delete-koszta="deleteKoszta"
/>

	</AppLayout>
</template>

<script>
import AppLayout from "../../../Layouts/App.vue";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import AddDelegacjaModal from "./AddDelegacjaModal.vue";
import UserColorModal from "./UserColorModal.vue";
import EditDelegacjaModal from "./EditDelegacjaModal.vue";
import AddKartaModal from "./AddKartaModal.vue";
import AddCelModal from "./AddCelModal.vue";
import AddPojazdModal from "./AddPojazdModal.vue";
import AddZleceniaModal from "./AddZleceniaModal.vue";
import WalutyModal from "./WalutyModal.vue";
import EditPobraneModal from "./EditPobraneModal.vue";
import EditKosztaModal from "./EditKosztaModal.vue";

const { hasRole, hasPermission } = usePermission();

export default {
	components: {
		AppLayout,
		AddDelegacjaModal,
		UserColorModal,
		EditDelegacjaModal,
		AddKartaModal,
		AddCelModal,
		AddPojazdModal,
		AddZleceniaModal,
		WalutyModal,
		EditPobraneModal,
		EditKosztaModal,
	},
	props: {
		users: Array,
		 zlecenia: Array,
		currencys: { type: Array, default: () => [] },
		karty: { type: Array, default: () => [] },
		cele: { type: Array, default: () => [] },
		pojazdy: { type: Array, default: () => [] },
		projects: Object,
		user_colors: { type: Array, default: () => [] },
	},
	data() {
		const today = new Date();
		return {
			kartyLocal: [...this.karty],
			celeLocal: [...this.cele],
			pojazdyLocal: [...this.pojazdy],
			zleceniaLocal: Array.isArray(this.zlecenia) ? [...this.zlecenia] : [],
			usersLocal: Array.isArray(this.users) ? [...this.users] : [],
			currencysLocal: [...this.currencys],
			selectedColorUser: null,
			selectedEditDelegacja: null,
			selectedDelegacja: null,
			userColorsLocal: this.user_colors,
			delegacje: [],
			loading: false,
			currentYear: today.getFullYear(),
			currentMonth: today.getMonth(),
			selectedYear: today.getFullYear(),
			selectedMonth: today.getMonth(),
			monthNames: [
				"Styczeń",
				"Luty",
				"Marzec",
				"Kwiecień",
				"Maj",
				"Czerwiec",
				"Lipiec",
				"Sierpień",
				"Wrzesień",
				"Październik",
				"Listopad",
				"Grudzień",
			],
			searchQuery: "",
currentPage: 1,
perPage: 5000,
		};
	},

	computed: {	filteredDelegacje() {
		const query = this.searchQuery.trim().toLowerCase();

		if (!query) {
			return this.formattedDelegacje;
		}

		return this.formattedDelegacje.filter((delegacja) => {
			const text = [
				delegacja.numer,
				delegacja.miejsce,
				delegacja.cel,
				delegacja.start_date,
				delegacja.end_date,
				delegacja.card,
				delegacja.project?.number,
				delegacja.user?.first_name,
				delegacja.user?.last_name,
				`${delegacja.user?.first_name || ""} ${delegacja.user?.last_name || ""}`,
			]
				.filter(Boolean)
				.join(" ")
				.toLowerCase();

			return text.includes(query);
		});
	},

	pageCount() {
		return Math.max(
			1,
			Math.ceil(this.filteredDelegacje.length / this.perPage)
		);
	},

	paginatedDelegacje() {
		const start = (this.currentPage - 1) * this.perPage;

		return this.filteredDelegacje.slice(
			start,
			start + this.perPage
		);
	},

	paginationStart() {
		if (!this.filteredDelegacje.length) {
			return 0;
		}

		return (this.currentPage - 1) * this.perPage + 1;
	},

	paginationEnd() {
		return Math.min(
			this.currentPage * this.perPage,
			this.filteredDelegacje.length
		);
	},

	visiblePages() {
		const total = this.pageCount;
		const current = this.currentPage;

		if (total <= 7) {
			return Array.from(
				{ length: total },
				(_, i) => i + 1
			);
		}

		let pages = [];

		if (current <= 4) {
			pages = [1, 2, 3, 4, 5, "...", total];
		} else if (current >= total - 3) {
			pages = [
				1,
				"...",
				total - 4,
				total - 3,
				total - 2,
				total - 1,
				total
			];
		} else {
			pages = [
				1,
				"...",
				current - 1,
				current,
				current + 1,
				"...",
				total
			];
		}

		return pages;
	},
		yearRange() {
			const years = [];

			for (let y = this.currentYear - 5; y <= this.currentYear + 1; y++) {
				years.push(y);
			}

			return years;
		},

		availableMonths() {

			return this.monthNames;
		},

		formattedMonth() {
			return `${this.monthNames[this.selectedMonth]} ${this.selectedYear}`;
		},

		formattedDelegacje() {
			return this.delegacje;
		},

	},

	watch: {
		searchQuery() {
		this.currentPage = 1;
	},

	perPage() {
		this.currentPage = 1;
	},

		selectedMonth() {
			this.getDelegacje();
		},

		selectedYear(newYear) {

			if (
				newYear === this.currentYear &&
				this.selectedMonth > this.currentMonth
			) {
				this.selectedMonth = this.currentMonth;
			}

			this.getDelegacje();

		}
	},
	mounted() {
		this.getDelegacje();
		this.refreshSlowniki();
	},

	methods: {
	goToPage(page) {
	if (page === "..." || page < 1 || page > this.pageCount) {
		return;
	}

	this.currentPage = page;
},

resetPagination() {
	this.currentPage = 1;
},

	getPojazdy(pojazd) {
	if (!pojazd) {
		return [];
	}
   return pojazd.split(',').map(p => p.trim());
},

		exportPdf(){
			window.open(
				route('kadry.delegacje.export.pdf',{
					year:this.selectedYear,
					month:this.selectedMonth + 1
				}),
				'_blank'
			);
		},

		exportExcel(){
			window.open(
				route('kadry.delegacje.export.excel',{
					year:this.selectedYear,
					month:this.selectedMonth + 1
				}),
				'_blank'
			);
		},
		async saveKoszta(payload){
			try {
				await axios.post(
					route('kadry.delegacje.koszta.store'),
					payload
				);
				await this.getDelegacje();
				this.successMsg(
					'Koszta zostały dodane.'
				);
			} catch(error){
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd zapisu kosztów.'
				);
			}
		},
		async updateKoszta(payload){
			try {
				await axios.put(
					route(
						'kadry.delegacje.koszta.update',
						payload.id
					),
					payload
				);
				await this.getDelegacje();
			} catch(error){
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd aktualizacji kosztów.'
				);
			}
		},
		async deleteKoszta(id){
			try {
				await axios.delete(
					route(
						'kadry.delegacje.koszta.delete',
						id
					)
				);
				await this.getDelegacje();
			} catch(error){
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd usuwania kosztów.'
				);
			}
		},	

		async saveKwota(payload){
			try {
				await axios.post(
					route('kadry.delegacje.kwoty.store'),
					payload
				);
				await this.getDelegacje();
				this.successMsg(
					'Kwota została dodana.'
				);
			} catch(error){
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd zapisu kwoty.'
				);
			}
		},
		async updateKwota(payload){
			try {
				await axios.put(
					route(
						'kadry.delegacje.kwoty.update',
						payload.id
					),
					payload
				);
				await this.getDelegacje();
			} catch(error){
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd aktualizacji kwoty.'
				);
			}
		},
		async deleteKwota(id){
			try {
				await axios.delete(
					route(
						'kadry.delegacje.kwoty.delete',
						id
					)
				);
				await this.getDelegacje();
			} catch(error){
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd usuwania kwoty.'
				);
			}
		},		
		async storeCurrency(payload) {
			try {
				payload.name = payload.name.toUpperCase();
				await axios.post(
					route('articles.currencys.store'),
					payload
				);
				await this.refreshSlowniki();
				this.successMsg('Waluta została dodana.');
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd podczas dodawania waluty.'
				);
			}
		},

		async updateCurrency(payload) {
			try {
				await axios.put(
					route(
						'delegacje.currencys.update',
						payload.id
					),
					payload
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Waluta została zaktualizowana.'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}			
						
		},
		async destroyCurrency(id) {
			try {
				await axios.delete(
					route(
						'delegacje.currencys.destroy',
						id
					)
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Waluta została usunięta'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
			
		},
		
		async createPojazdFromModal(payload) {
			try {
				await axios.post(
					route('kadry.pojazd.store'),
					payload
				);
				await this.refreshSlowniki();
				this.successMsg('Pojazd został dodany.');
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},
		async updatePojazdFromModal(payload) {
			try {
				await axios.put(
					route(
						'kadry.pojazd.update',
						payload.id
					),
					payload
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Pojazd został zaktualizowany.'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},
		async deletePojazdFromModal(id) {
			try {
				await axios.delete(
					route(
						'kadry.pojazd.delete',
						id
					)
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Pojazd został usunięty.'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},
		
		async createZleceniaFromModal(payload) {
			try {
				const { data } = await axios.post(
					route('kadry.delegacje.zlecenia.store'),
					payload
				);

				await this.refreshSlowniki();

				this.usersLocal.push({
					id: data.zlecenie.id,
					first_name: data.zlecenie.first_name,
					last_name: data.zlecenie.last_name,
				});

				this.usersLocal.sort((a, b) => {
					const lastNameCompare = a.last_name.localeCompare(b.last_name);
					if (lastNameCompare !== 0) {
						return lastNameCompare;
					}

					return a.first_name.localeCompare(b.first_name);
				});

				this.successMsg('Pracownik (zlecenie) został dodany.');
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ?? 'Błąd.'
				);
			}
		},
		async updateZleceniaFromModal(payload) {
			try {
				await axios.put(
					route(
						'kadry.delegacje.zlecenia.update',
						payload.id
					),
					payload
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Pracownik (zlecenie) został zaktualizowany.'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},
		async deleteZleceniaFromModal(id) {
			try {
				await axios.delete(
					route(
						'kadry.delegacje.zlecenia.delete',
						id
					)
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Pracownik (zlecenie) został usunięty.'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},		
		async createCelFromModal(payload) {
			try {
				await axios.post(
					route('kadry.cele.store'),
					payload
				);
				await this.refreshSlowniki();
				this.successMsg('Cel został dodany.');
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},
		async updateCelFromModal(payload) {
			try {
				await axios.put(
					route(
						'kadry.cele.update',
						payload.id
					),
					payload
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Cel został zaktualizowany.'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},
		async deleteCelFromModal(id) {
			try {
				await axios.delete(
					route(
						'kadry.cele.delete',
						id
					)
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Cel został usunięty.'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},

		async createKartaFromModal(payload) {
			try {
				await axios.post(
					route('kadry.karty.store'),
					payload
				);
				await this.refreshSlowniki();
				this.successMsg('Karta została dodana.');
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},
		async updateKartaFromModal(payload) {
			try {
				await axios.put(
					route(
						'kadry.karty.update',
						payload.id
					),
					payload
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Karta została zaktualizowana.'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},
		async deleteKartaFromModal(id) {
			try {
				await axios.delete(
					route(
						'kadry.karty.delete',
						id
					)
				);
				await this.refreshSlowniki();
				this.successMsg(
					'Karta została usunięta.'
				);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd.'
				);
			}
		},

		async refreshSlowniki() {
			const { data } = await axios.get(route('kadry.slowniki.list'));

			this.usersLocal = data.users;
			this.kartyLocal = data.karty;
			this.celeLocal = data.cele;
			this.pojazdyLocal = data.pojazdy;
			this.currencysLocal = data.currencys;
			this.zleceniaLocal = data.zlecenia;
		},

		async deleteDelegacja(id) {
			try {
				await axios.delete(route('kadry.delegacje.delete', id));
				this.selectedEditDelegacja = null;
				await Promise.all([
					this.getDelegacje(),
					this.refreshSlowniki()
				]);
				Toast.fire({
					icon: 'success',
					title: 'Delegacja została usunięta'
				});
			} catch (error) {
				Toast.fire({
					icon: 'error',
					title: 'Nie udało się usunąć delegacji',
					text: error.response?.data?.message || 'Błąd'
				});
			}
		},

		openEditDelegacja(delegacja) {
			this.selectedEditDelegacja = delegacja;
			this.$nextTick(() => {
				this.$refs.editDelegacjaModalRef.show();
			});
		},

		openEditPobrane(delegacja) {
			this.selectedDelegacja = delegacja;
			this.$nextTick(() => {
				this.$refs.editPobraneModalRef.show();
			});
		},
		
		openEditKoszta(delegacja) {
			this.selectedDelegacja = delegacja;
			this.$nextTick(() => {
				this.$refs.editKosztaModalRef.show();
			});
		},
		
		async updateDelegacja(payload) {
			try {
				await axios.put(
					route(
						'kadry.delegacje.update',
						payload.id
					),
					payload
				);
				this.successMsg(
					'Delegacja zaktualizowana.'
				);
				this.selectedEditDelegacja = null;

				await Promise.all([
					this.getDelegacje(),
					this.refreshSlowniki()
				]);
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd aktualizacji.'
				);
			}
		},
		async saveUserColor(payload) {

			try {
				await axios.post(route('kadry.users.color.save'), payload);
				const index = this.userColorsLocal.findIndex(x => x.user_id === payload.user_id);
				if (index >= 0) { this.userColorsLocal[index] = payload; }
				else { this.userColorsLocal.push(payload); }
				this.successMsg('Kolor użytkownika zapisany.');
				this.selectedColorUser = null;
				await this.getDelegacje();
			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Błąd zapisu koloru.'
				);
			}
		},

		async getDelegacje() {
			this.loading = true;
			try {
				const { data } = await axios.get(route('kadry.delegacje.list'), {
					params: {
						year: this.selectedYear,
						month: this.selectedMonth
					}
				});
				this.delegacje = data;

			} catch (e) {
				console.log(e);
				console.log(e.response);

				this.errorMsg(
					e.response?.data?.message ?? e.message
				);
			} finally {
				this.loading = false;
			}
		},

		openUserColor(user) {
			this.selectedColorUser = user;
			this.$nextTick(() => {
				this.$refs.userColorModalRef.show();
			});
		},

		addDelegacja() {
			this.$refs.addDelegacjaModalRef.show();
		},

		addKarta() {
			this.$refs.addKartaModalRef.show();
		},

		addCel() {
			this.$refs.addCelModalRef.show();
		},
		addPojazd() {
			this.$refs.addPojazdModalRef.show();
		},
		addZlecenia() {
			this.$refs.addZleceniaModalRef.show();
		},
		addWaluta() {
			this.$refs.addWalutaModalRef.show();
		},

		async createDelegacjaFromModal(payload) {
			try {
				const { data } = await axios.post(
					route('kadry.delegacje.store'),
					payload
				);
				if (data.success) {
					this.successMsg('Delegacja została dodana.');
					await Promise.all([
						this.getDelegacje(),
						this.refreshSlowniki()
					]);
				}

			} catch (error) {
				this.errorMsg(
					error.response?.data?.message ??
					'Wystąpił błąd podczas zapisu.'
				);
				console.error(error);
			}
		},

		successMsg(resp) {
			Toast.fire({
				position: 'top-end',
				toast: true,
				icon: 'success',
				title: 'Sukces!',
				html: resp,
				showClass: { popup: 'animate__animated animate__fadeInDown' },
				hideClass: { popup: 'animate__animated animate__fadeOutUp' },
				timer: 2500,
				timerProgressBar: true,
				showConfirmButton: false,
				showCloseButton: true
			});
		},

		errorMsg(resp) {
			Toast.fire({
				position: 'top-end',
				toast: true,
				icon: 'warning',
				title: 'Błąd!',
				html: resp,
				showClass: { popup: 'animate__animated animate__fadeInDown' },
				hideClass: { popup: 'animate__animated animate__fadeOutUp' },
				timer: 2500,
				timerProgressBar: true,
				showConfirmButton: false,
				showCloseButton: true
			});
		},

	},
};
</script>
<style scoped>
.delegacja-nierozliczona {
	background-color: #e6e7e8 !important;
}

.saldo-czerwone {
	color: red;
	font-weight: bold;
}
.delegacja-usunieta {
	background-color: #eeeeee !important;
	color: #888 !important;
	text-decoration: line-through;
	opacity: 0.65;
}

.delegacja-usunieta td {
	background-color: #eeeeee !important;
	color: #888 !important;
	text-decoration: line-through;
}

.delegacja-usunieta a,
.delegacja-usunieta span,
.delegacja-usunieta div {
	color: #888 !important;
	text-decoration: line-through;
}
.delegacje-table-wrapper {
	max-height: calc(100vh - 280px);
	overflow: auto;
	border-radius: 6px;
}

/* Sticky nagłówek */
.delegacje-table thead th {
	position: sticky;
	top: 0;
	z-index: 10;
	background: #fff;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

/* Własny wygląd toolbaru */
.table-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;
	flex-wrap: wrap;
}

.search-box {
	position: relative;
	width: 420px;
	max-width: 100%;
}

.search-box .form-control {
	height: 38px;
	padding-left: 38px;
	padding-right: 38px;
	border-radius: 6px;
	border: 1px solid #d9d9d9;
	box-shadow: none;
}

.search-box .form-control:focus {
	border-color: #4361ee;
	box-shadow: 0 0 0 2px rgba(67, 97, 238, 0.12);
}

.search-box > i {
	position: absolute;
	left: 13px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	color: #888;
}

.search-clear {
	position: absolute;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
	border: 0;
	background: transparent;
	color: #888;
	cursor: pointer;
	padding: 4px 7px;
}

.search-clear:hover {
	color: #333;
}

.table-info {
	display: flex;
	align-items: center;
	gap: 12px;
	color: #777;
	font-size: 13px;
}

.table-info strong {
	color: #333;
}

.table-info .form-select {
	width: auto;
	min-width: 105px;
}

/* Paginacja */
.pagination-wrapper {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 15px 5px 5px;
	gap: 15px;
}

.pagination-info {
	color: #777;
	font-size: 13px;
	white-space: nowrap;
}

.pagination-custom {
	display: flex;
	align-items: center;
	gap: 4px;
}

.page-btn {
	min-width: 34px;
	height: 34px;
	padding: 0 9px;
	border: 1px solid #ddd;
	background: #fff;
	border-radius: 5px;
	color: #555;
	cursor: pointer;
	transition: all 0.15s ease;
}

.page-btn:hover:not(:disabled) {
	background: #f2f4f7;
	border-color: #bbb;
	color: #222;
}

.page-btn.active {
	background: #4361ee;
	border-color: #4361ee;
	color: #fff;
	font-weight: 600;
}

.page-btn:disabled {
	opacity: 0.45;
	cursor: not-allowed;
}

.page-dots {
	min-width: 28px;
	text-align: center;
	color: #999;
}

/* Lepszy sticky header przy poziomym scrollu */
.delegacje-table {
	margin-bottom: 0;
}

.delegacje-table thead {
	position: sticky;
	top: 0;
	z-index: 10;
}

/* Na mniejszych ekranach */
@media (max-width: 768px) {
	.table-toolbar {
		align-items: stretch;
	}

	.search-box {
		width: 100%;
	}

	.table-info {
		justify-content: space-between;
	}

	.pagination-wrapper {
		flex-direction: column;
		align-items: stretch;
	}

	.pagination-custom {
		justify-content: center;
	}
}
.delegacje-table thead th {
	position: sticky;
	top: 0;
	z-index: 20;

	background: #eef1f5 !important;
	color: #2f3542;

	border-top: 1px solid #d9dee5 !important;
	border-bottom: 2px solid #c5cbd3 !important;

	box-shadow: 0 3px 8px rgba(0, 0, 0, 0.10);

	font-weight: 600;
}

</style>